(function () {
  // ---- Configuration ----
  // The list of currently out-of-stock preorder product IDs is computed in
  // layout/theme.liquid from each candidate product's real-time stock level
  // and exposed as window.preorderProductIds, so this popup automatically
  // stops firing for a product as soon as it's restocked (inventory_quantity > 0),
  // with no code edit needed here.
  var PREORDER_PRODUCT_IDS = (window.preorderProductIds || []);

  var DISPATCH_MESSAGE =
    'To save you a second delivery charge, we ship pre-order items together with everything else in your basket. Your full order will be dispatched from 19th October, once the pre-order item is ready.';

  function injectStyles() {
    if (document.getElementById('preorder-notice-styles')) return;
    var style = document.createElement('style');
    style.id = 'preorder-notice-styles';
    style.textContent =
      '.preorder-notice-overlay{position:fixed;inset:0;background:rgba(0,0,0,.5);display:flex;' +
      'align-items:center;justify-content:center;z-index:99999;padding:2rem;opacity:0;' +
      'transition:opacity .2s ease;}' +
      '.preorder-notice-overlay.is-visible{opacity:1;}' +
      '.preorder-notice-box{background:#fff;color:#1a1a1a;max-width:40rem;width:100%;' +
      'border-radius:.8rem;padding:2.4rem;box-shadow:0 1rem 3rem rgba(0,0,0,.25);' +
      'font-family:inherit;position:relative;transform:translateY(1rem);' +
      'transition:transform .2s ease;}' +
      '.preorder-notice-overlay.is-visible .preorder-notice-box{transform:translateY(0);}' +
      '.preorder-notice-box h3{margin:0 0 1rem;font-size:1.8rem;}' +
      '.preorder-notice-box p{margin:0 0 1.6rem;line-height:1.5;font-size:1.4rem;}' +
      '.preorder-notice-close{position:absolute;top:1.2rem;right:1.2rem;background:none;' +
      'border:none;font-size:2rem;line-height:1;cursor:pointer;padding:.4rem;}' +
      '.preorder-notice-button{display:inline-block;background:#1a1a1a;color:#fff;' +
      'border:none;border-radius:.4rem;padding:1.1rem 2rem;font-size:1.4rem;cursor:pointer;}';
    document.head.appendChild(style);
  }

  function showModal() {
    injectStyles();

    var overlay = document.createElement('div');
    overlay.className = 'preorder-notice-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'preorder-notice-title');

    overlay.innerHTML =
      '<div class="preorder-notice-box">' +
      '<button type="button" class="preorder-notice-close" aria-label="Close">&times;</button>' +
      '<h3 id="preorder-notice-title">Your pre-order is in your basket</h3>' +
      '<p>' + DISPATCH_MESSAGE + '</p>' +
      '<button type="button" class="preorder-notice-button">Got it</button>' +
      '</div>';

    document.body.appendChild(overlay);
    requestAnimationFrame(function () {
      overlay.classList.add('is-visible');
    });

    function close() {
      overlay.classList.remove('is-visible');
      setTimeout(function () {
        overlay.remove();
      }, 200);
      document.removeEventListener('keyup', onKeyup);
    }

    function onKeyup(evt) {
      if (evt.code === 'Escape') close();
    }

    overlay.addEventListener('click', function (evt) {
      if (evt.target === overlay) close();
    });
    overlay.querySelector('.preorder-notice-close').addEventListener('click', close);
    overlay.querySelector('.preorder-notice-button').addEventListener('click', close);
    document.addEventListener('keyup', onKeyup);

    overlay.querySelector('.preorder-notice-button').focus();
  }

  function cartDataIncludesPreorder(cartData) {
    if (!cartData) return false;
    if (cartData.product_id) {
      return PREORDER_PRODUCT_IDS.indexOf(cartData.product_id) !== -1;
    }
    if (Array.isArray(cartData.items)) {
      return cartData.items.some(function (item) {
        return PREORDER_PRODUCT_IDS.indexOf(item.product_id) !== -1;
      });
    }
    return false;
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (cartDataIncludesPreorder(event && event.cartData)) {
        // Small delay so it doesn't fight the cart drawer's own open animation.
        setTimeout(showModal, 400);
      }
    });
  }

  init();
})();
